import { render, staticRenderFns } from "./Modalities.vue?vue&type=template&id=bfd1349a&scoped=true"
import script from "./Modalities.vue?vue&type=script&lang=js"
export * from "./Modalities.vue?vue&type=script&lang=js"
import style0 from "./Modalities.vue?vue&type=style&index=0&id=bfd1349a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd1349a",
  null
  
)

export default component.exports